module.exports = __webpack_public_path__ + "img/total_bucket_card.4d746b3d.svg";